import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type Person = components['schemas']['Person'];
export type PersonPage = components['schemas']['PersonPage'];
export type PeopleRole = components['schemas']['PeopleRole'];

export interface PeopleQuery {
  q?: string | undefined;
  role?: PeopleRole | undefined;
  page: number;
  pageSize: number;
}

/** The users whose pay a pay viewer may view (ADR 0028). */
export function usePeople({ q, role, page, pageSize }: PeopleQuery) {
  const api = useApiClient();
  const query = { ...(q ? { q } : {}), ...(role ? { role } : {}), page, pageSize };
  return useQuery({
    queryKey: queryKeys.peoplePage(query),
    queryFn: () => unwrap(api.GET('/api/viewer/users', { params: { query } })),
    placeholderData: keepPreviousData,
  });
}
